module.exports = __webpack_public_path__ + "media/src/fonts/GillSansProCyrillic-Medium-408fa4ac83bea7913b5b20b838b41cda.woff";